import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17 * (props.wx ?? 1)}
    height={25 * (props.hx ?? 1)}
    viewBox="0 0 17 25"
    fill="none"
    className={props.className}
  >
    <mask
      id="path-1-outside-1_4891_3214"
      width={17}
      height={25}
      x={0}
      y={0}
      fill="#000"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#fff" d="M0 0h17v25H0z" />
      <path d="M8.5 23.36c1.284 0 4.625 1.69 6.554-.423 1.546-1.694.975-5.766-.133-8.507-.412-1.02-.34-1.99-.323-3.09.082-5.23-.966-10.06-2.74-10.064-1.217-.003-.94 7.63-3.233 8.39-.935.31-1.34-2.095-1.474-4.513-.118-2.123.528-3.354.058-3.952-.44-.56-2.083-.06-3.374 2.92-.793 1.829-1.367 4.219-1.433 7.218-.025 1.1.09 2.072-.323 3.09-1.108 2.742-1.68 6.815-.133 8.508 1.93 2.114 5.27.422 6.554.422" />
    </mask>
    <path
      fill={props.fill || '#E4E4E7'}
      d="M8.5 23.36c1.284 0 4.625 1.69 6.554-.423 1.546-1.694.975-5.766-.133-8.507-.412-1.02-.34-1.99-.323-3.09.082-5.23-.966-10.06-2.74-10.064-1.217-.003-.94 7.63-3.233 8.39-.935.31-1.34-2.095-1.474-4.513-.118-2.123.528-3.354.058-3.952-.44-.56-2.083-.06-3.374 2.92-.793 1.829-1.367 4.219-1.433 7.218-.025 1.1.09 2.072-.323 3.09-1.108 2.742-1.68 6.815-.133 8.508 1.93 2.114 5.27.422 6.554.422"
    />
    <path
      d="M8.49975 23.3593C9.78427 23.3593 13.1247 25.0506 15.0541 22.9373C16.6003 21.2435 16.0292 17.1706 14.9209 14.4299C14.5086 13.4101 14.581 12.4398 14.5984 11.3394C14.6795 6.11033 13.6325 1.27908 11.8585 1.27568C10.6406 1.27325 10.9182 8.90584 8.62526 9.66658C7.69024 9.9766 7.28428 7.57116 7.15057 5.15262C7.03327 3.02954 7.67865 1.79869 7.20945 1.20096C6.76921 0.640601 5.12604 1.14177 3.83525 4.12019C3.04215 5.94974 2.4677 8.33966 2.40157 11.3394C2.37695 12.4398 2.49137 13.4106 2.07913 14.4299C0.97081 17.1711 0.399742 21.244 1.94589 22.9373C3.87531 25.0506 7.21573 23.3593 8.50025 23.3593H8.49975Z"
      stroke={props.stroke || '#A1A1AA'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      mask="url(#path-1-outside-1_4891_3214)"
    />
  </svg>
);
export default SvgNormal;
